import React, { Component } from "react";
import { Link } from "react-router-dom";
import {resetSearch} from '../../store/actions/machineActions'
import {connect} from 'react-redux'
import {
    NavLink,
    Button,
  } from "reactstrap";

class AddUser extends Component {
  render() {
    return (
      <div>
        <Button color="success" outline size="md" block onClick={this.props.resetSearch}>
          <NavLink tag={Link} to="/signup" className="text-success">
            Register New User
          </NavLink>
        </Button>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return{
    resetSearch: () => dispatch(resetSearch())
  }
}


export default connect(null,mapDispatchToProps)(AddUser);
